/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import type { FormHTMLAttributes } from "react";
import { FormProvider, type FieldValues, type SubmitHandler, type UseFormReturn } from "react-hook-form";

interface CustomFormContainerProps<T extends FieldValues = FieldValues> {
  formContext: UseFormReturn<T>;
  onSuccess?: SubmitHandler<T>;
  FormProps?: FormHTMLAttributes<HTMLFormElement>;
  children?: React.ReactNode;
}

const CustomFormContainer = <T extends FieldValues = FieldValues>({
  formContext,
  onSuccess,
  FormProps,
  children
}: CustomFormContainerProps<T>): React.ReactElement => {
  return (
    <FormProvider {...formContext}>
      <form
        noValidate
        {...FormProps}
        onSubmit={ onSuccess
            ? formContext.handleSubmit(onSuccess)
            : () => console.warn('Submit handler is missing!')
        }
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default CustomFormContainer;
